import List from "../../containers/Hotels/List";
import Entry from "../../containers/Hotels";

const hotelRoutes = [
  {
    path: "/hotels",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/hotels/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/hotels/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default hotelRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/hotels.jsx